import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_ARTMODELE_SCHEMA_LITERAL = {
    title: 'Schéma ArtModèles',
    description: 'ArtModèles',
    version: 0,
    keyCompression: false,
    primaryKey: 'CBMARQ_STR',
    type: 'object',
    properties: {
        CBMARQ_STR: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        AR_REF: { type: 'string' },
        MO_NO: { type: 'number' },
        AM_DOMAINE: { type: 'number' }
    },
    required: [ 'CBMARQ', 'AR_REF', 'MO_NO', 'AM_DOMAINE' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(F_ARTMODELE_SCHEMA_LITERAL);
export type RxFArtModeleDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_ARTMODELE_SCHEMA: RxJsonSchema<RxFArtModeleDocumentType> = F_ARTMODELE_SCHEMA_LITERAL;
